/*
 * @Author: 李洪峰 lihongfeng@163.com
 * @Date: 2023-07-19 18:54:26
 * @LastEditors: 李洪峰 lihongfeng@163.com
 * @LastEditTime: 2023-08-31 17:50:44
 * @FilePath: \file-management\src\api\config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
let financeBasicLv = 'api-finbasic'; // 吕春光 api-finbasic-lv
let financeBasicQzc = 'api-finbasic'; // 乔真诚 api-finbasic-qzc
let financeJournalLv = 'api-finance-journal'; // 吕春光 api-finance-journal-lv
let financeReimburse = 'api-finance-reimburse' //报帐中心
let financeJournalWr = 'api-finance-engine'; //会计引擎
let financeImagecenter = 'api-invoice-imagecenter'
let financeInvoicecenter = 'api-invoice-invoicecenter'//票
const PURCHASE = 'api-scm-purchase'
const ASSET = 'api-finance-asset'
const ARCHIVER = 'ctx-qy-archive'    //档案

export { financeBasicLv, financeBasicQzc, financeJournalLv, financeReimburse, financeJournalWr, financeImagecenter, financeInvoicecenter, PURCHASE, ASSET, ARCHIVER }



// WEBPACK FOOTER //
// ./src/api/config.js